import $ from 'jquery';
(function(){
    'use strict';

    // Global variables
    let currentCookingMethod = 'gas';
    let newCookingMethod = 'elect';
    let existingGas;
    let finalCurrentCost;
    let finalNewCost;

    class cookingInputs{
        constructor(energyType, smallEnergy, smallHours, largeEnergy, largeHours, energyRate, dailyCharge) {
            this.energyType = energyType;
            this.smallEnergy = smallEnergy;
            this.smallHours = smallHours;
            this.largeEnergy = largeEnergy;
            this.largeHours = largeHours;
            this.energyRate = energyRate;
            this.dailyCharge = dailyCharge;
        }
    }

    class energyResults{
        constructor(finalConsumed, finalCost, energyType) {
            this.finalConsumed = finalConsumed;
            this.finalCost = finalCost;
            this.energyType = energyType;
        }
    }

    // show only gas fields on load for current cooktop
    $('.current-cook_electric').parent('div').parent('div').css('display', 'none');
    $('.current-cook_gas').parent('div').parent('div').removeAttr('style');
    // show only electric fields on load for new cooktop
    $('.new-cook_gas').parent('div').parent('div').css('display', 'none');
    $('.new-cook_electric').parent('div').parent('div').removeAttr('style');

    // get Ceramic and induction defaults
    let ceramicSmall = $('.hidden-electCeramicSmallInputPower').html();
    let ceramicLarge = $('.hidden-electCeramicLargeInputPower').html();
    let inductSmall = $('.hidden-electInductionSmallInputPower').html();
    let inductLarge = $('.hidden-electInductionLargeInputPower').html();

    // Hide/show fields depending on gas/electric
    $('.current-cook_type').on('change', function () {
        let choice = this.value;
        if (choice === 'gas') {
            $('.current-cook_electric').parent('div').parent('div').css('display', 'none');
            $('.current-cook_gas').parent('div').parent('div').removeAttr('style');
            currentCookingMethod = 'gas';
        } else {
            $('.current-cook_gas').parent('div').parent('div').css('display', 'none');
            $('.current-cook_electric').parent('div').parent('div').removeAttr('style');
            currentCookingMethod = 'elect';
            if (choice === "ceramic") {
                $('.current-cook_watts--small').val(ceramicSmall);
                $('.current-cook_watts--large').val(ceramicLarge);
            } else {
                $('.current-cook_watts--small').val(inductSmall);
                $('.current-cook_watts--large').val(inductLarge);
                
            }
        }
    })
   
    $('.new-cook_type').on('change', function () {
        let choice = this.value;
        if (choice === 'gas') {
            $('.new-cook_electric').parent('div').parent('div').css('display', 'none');
            $('.new-cook_gas').parent('div').parent('div').removeAttr('style');
            newCookingMethod = 'gas';
        } else {
            $('.new-cook_gas').parent('div').parent('div').css('display', 'none');
            $('.new-cook_electric').parent('div').parent('div').removeAttr('style');
            newCookingMethod = 'elect';
            if (choice === "ceramic") {
                $('.new-cook_watts--small').val(ceramicSmall);
                $('.new-cook_watts--large').val(ceramicLarge);
            } else {
                $('.new-cook_watts--small').val(inductSmall);
                $('.new-cook_watts--large').val(inductLarge);
                
            }
        }
    })

    
    // change inputs update values
    $('.cooking-calculator__wrapper input').on('change', function (input) {
        input.currentTarget.attributes.value.value = this.value;
    })


    function printCurrentFinalCost(obj) {
        $('.current-cook_units').html("<sup>1, 2</sup>");
        let currentCookingCost = calculateSingleSource(obj);
        $('.current-cook_usage').html(currentCookingCost.finalConsumed);
        $('.current-cook_cost').html(currentCookingCost.finalCost);
        if (obj.energyType === "elect") {
            $('.current-cook_units').prepend("Electricity (kWh)")
        } else {
            $('.current-cook_units').prepend("Gas (MJ)")
        }
        finalCurrentCost = currentCookingCost.finalCost;
    }
    

    function printNewFinalCost(obj) {
        $('.new-cook_units').html("<sup>1, 2</sup>");
        let newCookingCost = calculateSingleSource(obj);
        $('.new-cook_usage').html(newCookingCost.finalConsumed);
        $('.new-cook_cost').html(newCookingCost.finalCost);
        if (obj.energyType === "elect") {
            $('.new-cook_units').prepend("Electricity (kWh)")
        } else {
            $('.new-cook_units').prepend("Gas (MJ)")
        }
        finalNewCost = newCookingCost.finalCost;
    }
    

    function calculateSingleSource(obj) {
        let additionalCost = 0;
        let amountOfEnergyConsumed = 0;
        
        if (obj.energyType === "gas") {
            amountOfEnergyConsumed = (obj.smallEnergy * obj.smallHours * 52) + (obj.largeEnergy * obj.largeHours * 52);
        } else {
            amountOfEnergyConsumed = (obj.smallEnergy / 1000 * obj.smallHours * 52) + (obj.largeEnergy / 1000 * obj.largeHours * 52);
        }
        let cost = amountOfEnergyConsumed * obj.energyRate;
        
        // add gas charge if not existing gas
        if (obj.energyType === 'gas' && existingGas === 'No') {
            additionalCost = obj.dailyCharge * 365;
        }
        
        let totalCost = ((cost + additionalCost) / 100);
        
        var results = new energyResults(
            Math.round(amountOfEnergyConsumed),
            totalCost.toFixed(2),
            obj.energyType
        )
        return results;
    }


    function generateChart() {
        var Chart = require('chart.js');
        var ctx = document.getElementById('myChart');
        // eslint-disable-next-line no-unused-vars
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ['Current', 'New'],
                datasets: [{
                    label: 'Remove this title',
                    data: [finalCurrentCost, finalNewCost],
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)'
                    ],
                    borderWidth: 1
                }],
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.yLabel;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
    }


    // Caculate click
    $('.cooking-calculator__wrapper').find('.sq-form-submit').on('click', function (e) {

         // Is there existing gas
        existingGas = $('.cook_existing-gas')[0].value;
        
        // Create object for current cooking
        if (currentCookingMethod === "gas") {
            var current = new cookingInputs(
                currentCookingMethod,
                $('.current-cook_mj--small')[0].value,
                $('.current-cook_ghours--small')[0].value,
                $('.current-cook_mj--large')[0].value,
                $('.current-cook_ghours--large')[0].value,
                $('.current-cook_gas-rate')[0].value,
                $('.current-cook_gas-charge')[0].value
            )
        } else {
            var current = new cookingInputs(
                currentCookingMethod = 'elect',
                $('.current-cook_watts--small')[0].value,
                $('.current-cook_ehours--small')[0].value,
                $('.current-cook_watts--large')[0].value,
                $('.current-cook_ehours--large')[0].value,
                $('.current-cook_elect-rate')[0].value
            )
        }

        // Create object for new cooking
        if (newCookingMethod === "gas") {
            var newCook = new cookingInputs(
                newCookingMethod = 'gas',
                $('.new-cook_mj--small')[0].value,
                $('.new-cook_ghours--small')[0].value,
                $('.new-cook_mj--large')[0].value,
                $('.new-cook_ghours--large')[0].value,
                $('.new-cook_gas-rate')[0].value,
                $('.new-cook_gas-charge')[0].value
            )
        } else {
            var newCook = new cookingInputs(
                newCookingMethod,
                $('.new-cook_watts--small')[0].value,
                $('.new-cook_ehours--small')[0].value,
                $('.new-cook_watts--large')[0].value,
                $('.new-cook_ehours--large')[0].value,
                $('.new-cook_elect-rate')[0].value
            )
        }

        console.log('current', current);
        console.log('new', newCook);

        // add the required attribute to the existing-gas input.
        if (currentCookingMethod === 'gas' || newCookingMethod === "gas") {
            $('.cook_existing-gas').prop('required', true);
        }
        
        if (currentCookingMethod === 'elect' && newCookingMethod === 'elect') {
            $('.cook_existing-gas').prop('required', false);
        }
        
        // remove existing graph and add new blank.
        $('#myChart').remove();
        $('.cook_graph').append('<canvas id="myChart" width="400" height="400"></canvas>');
        
        let entireForm = document.getElementsByClassName('cooking-calculator__wrapper')[0].querySelector('form');
        let isFormValid = entireForm.checkValidity(entireForm);

        if (isFormValid) {
           
            e.preventDefault();
    
            printCurrentFinalCost(current);
            printNewFinalCost(newCook);
    
            // show results section
            $('.calculator_results').slideDown();
    
            // print savings
            let savings = (finalCurrentCost - finalNewCost).toFixed(2);
            $('.cook_savings-value').html(savings);
    
            generateChart();

            $('html, body').animate({
				scrollTop: $("#calculator-results").offset().top
			}, 800);
        }   
    })
}());
